import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarOrcamentos(axios, parametros) {        
    parametros.operacao = 'pesquisarOrcamentos'

    let retorno = {}

    await axios.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoPesquisarOrcamentos.js